import React, { useState } from "react";
import "./Bet_Select_section.css"
import ColorButtons from "../ColorButtons/ColorButtons";
import ActionButtons from "../ActionButtons/ActionButtons";
import NumberGrid from "../NumberGrid/NumberGrid";
import WinGoModal from "../../Common/Common_Component/Common_Modal/WinGoModal/WinGoModal";

function Bet_Select_section() {
  const [modalData, setModalData] = useState({ open: false, value: '', type: '' });
  return (
    <>
      <section className="Bet_Select_section">
        <ColorButtons />
        <NumberGrid />
        <ActionButtons  setModalData={setModalData}/>
      </section>

      {modalData.open && (
        <WinGoModal
          selectedValue={modalData.value} 
          type={modalData.type} 
          onClose={() => setModalData({ ...modalData, open: false })}
        />
      )}
    </>
  );
}

export default Bet_Select_section;
